import { marginPlanApi } from 'app/services/api';

import { createNamedActions } from 'utils/namedActionTypesProxy';

export const PREVIEW_ACTION_TYPE = createNamedActions('marginCenter/preview', {
  GET_MARGIN_PREVIEW: 'GET_MARGIN_PREVIEW',
  SET_PREVIEW_LOADING: 'SET_PREVIEW_LOADING',
  SET_PREVIEW_ERROR: 'SET_PREVIEW_ERROR',
});

// Margin Center MC-7/MC-8 (DEV-4969/DEV-4970): draft-vs-live diff/preview for the PreviewPage diff
// table, heatmap, curve, and summary. DEV-4977/MC-14 additionally layers
// summary.coarseFloatingPipeline{LoanCount,LoanAmount,DollarImpact} onto that response — the v1 COARSE,
// real source for Preview's floating-pipeline impact stat (the per-cell floatingPipelineDollarImpact
// stays 0 until a separate per-(program×rate) attribution spike lands). Compute-on-read — no writes.
// `request` is a MarginPreviewRequest (NoteRates/SubCompanyId/BranchId/BrokerId), all optional.
export const getMarginPlanPreviewAction =
  (marginPlanId, request = {}) =>
  async dispatch => {
    dispatch({ type: PREVIEW_ACTION_TYPE.SET_PREVIEW_LOADING, payload: true });

    try {
      const { data } = await marginPlanApi.previewPlan(marginPlanId, request);

      return dispatch({ type: PREVIEW_ACTION_TYPE.GET_MARGIN_PREVIEW, payload: data });
    } catch {
      return dispatch({ type: PREVIEW_ACTION_TYPE.SET_PREVIEW_ERROR });
    }
  };
